import { createFileRoute } from '@tanstack/react-router'
import { EvaluationJobs } from '@/features/admin/evaluation-jobs'

interface EvaluationJobsSearch {
  evalId?: string
  evalType?: 'batch' | 'individual'
}

export const Route = createFileRoute('/_authenticated/admin/evaluation-jobs')({
  component: EvaluationJobs,
  validateSearch: (search: Record<string, unknown>): EvaluationJobsSearch => ({
    evalId: typeof search.evalId === 'string' ? search.evalId : undefined,
    evalType:
      search.evalType === 'batch' || search.evalType === 'individual'
        ? search.evalType
        : undefined,
  }),
})
